/* eslint-disable no-unused-vars */
import mrc from './melzo-rest-client';
import {
  translatePptvrToMelzo
} from '../utils/pptvr-to-melzo-translator';
import {
  factory
} from '../../viewer/factoryjs/create-factory';

function getProjectDetails(projectId, uid) {
  return mrc
    .get('projects/private/' + uid + '/' + projectId, {
      headers: {
        'x-access-token': 'null'
      },
      baseURL: "https://ptpvr.com"
    })
    .then(res => {
      factory.project = res.data;
      // const projectJSON = translatePptvrToMelzo(res.data);
      return res.data;
    })
    .catch(err => Promise.reject(err));
}

export default getProjectDetails;
